import InsiderThreatMatrix from './components/InsiderThreatMatrix';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <div className="App">
      <InsiderThreatMatrix />
      <Footer />
    </div>
  );
}

export default App;